<template>
    <div>
        <el-form ref="searchForm" :model="searchData" inline>
            <el-form-item label="UID">
                <el-input v-model.number="searchData.user_id" size="mini" />
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model.number="searchData.mobile" size="mini" maxlength="11" />
            </el-form-item>
            <el-form-item label="微信昵称">
                <el-input v-model.number="searchData.nickname" size="mini" />
            </el-form-item>
            <el-form-item>
                <el-button size="mini" @click="handlerSearch">
                    查找
                </el-button>
            </el-form-item>
        </el-form>

        <el-table
            :data="data"
        >
            <el-table-column
                prop="user_id"
                label="UID"
            />
            <el-table-column
                prop="nickname"
                label="微信昵称"
            />
            <el-table-column
                prop="avatar"
                label="微信头像">
                <template slot-scope="scope">
                    <el-image
                        :src="scope.row.avatar || ''"
                        style="width: 40px; height: 40px;"
                    />
                </template>
            </el-table-column>
            <el-table-column
                prop="is_partner"
                label="合伙人身份"
            >
                <template slot-scope="{row}">
                    <span> {{ row.is_partner | isRegister }} </span>
                </template>
            </el-table-column>

            <el-table-column
                prop="cid"
                label="渠道号"
            />
            <el-table-column
                prop="invite_id"
                label="邀请人"
            />
            <el-table-column
                prop="price"
                label="付费金额"
            >
                <template slot-scope="{row}">
                    <span> {{ row.price | formatAmount }} </span>
                </template>
            </el-table-column>

            <el-table-column
                prop="time"
                label="付费时间"
            />
            <el-table-column
                prop="user_id"
                label="操作"
            >
                <template slot-scope="scope">
                    <div class="edit-btn-box">
                        <!-- <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button> -->
                        <el-button size="mini" @click="handleAddRemark(scope.row.user_id)">添加备注</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="remark"
                label="备注">
                <template slot-scope="scope">
                    <el-col>{{ getRemarkTime(scope.row.remark) }}</el-col>
                    <el-col>{{ getRemarkText(scope.row.remark) }}</el-col>
                    <el-button class="all-remark" v-show="scope.row.remark" @click="allRemark(scope.row.user_id)">查看全部</el-button>
                </template>
            </el-table-column>
        </el-table>
        <page-bar
            :currentPageCount="data.length"
            @page-changed="loadData"
        ></page-bar>

        <el-dialog title="编辑" :visible.sync="showUpdateStatus" class="edit-box">
            <div class="edit-info"><span class="span1">用户微信昵称：</span><span>{{ currentUserInfo.nickname }}</span></div>
            <div class="edit-info"><span class="span1">用户手机号：</span><span>{{ currentUserInfo.mobile }}</span></div>
            <div>
                <span class="span1">身份状态:</span>
                <el-select v-model="status" label="状态" placeholder="请选择身份状态">
                    <el-option  v-if="currentUserInfo.level === 10" value="10" label="预备合伙人">预备合伙人</el-option>
                    <el-option value="20" label="普通合伙人">普通合伙人</el-option>
                    <el-option v-if="currentUserInfo.level > 10" value="30" label="高级合伙人">高级合伙人</el-option>
                </el-select>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showUpdateStatus = false">取 消</el-button>
                <el-button type="primary" @click="confirmUpdateStatus">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="确定更改用户信息" :visible.sync="showConfirmUpdateStatus">
            <div>确定更改身份状态为: {{ statusText }} ?</div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showConfirmUpdateStatus = false">取 消</el-button>
                <el-button type="primary" @click="updateStatus">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="showRemarks" title="添加备注" @close="cancelRemarks">
            <el-input
                type="textarea"
                :rows="3"
                placeholder="输入备注内容，最多100字"
                v-model="remarkTextarea"
            >
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelRemarks">取 消</el-button>
                <el-button type="primary" @click="updateRemarks">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="全部备注" :visible.sync="showRemarkList">
            <el-table :data="remarkList">
                <el-table-column
                    prop="time"
                    label="备注时间"
                />
                <el-table-column
                    prop="operator_name"
                    label="添加人"
                />
                <el-table-column
                    prop="remark"
                    label="备注内容"
                />
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showRemarkList = false">取 消</el-button>
                <el-button type="primary" @click="showRemarkList = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import PageBar from "../ui/PageBar";
import request from "@/api/request";

const level_enum = [
    {
        value: 10,
        text: "预备合伙人"
    },
    {
        value: 20,
        text: "普通合伙人"
    },
    {
        value: 30,
        text: "高级合伙人"
    },
]
export default {
    name: 'PartnerList',
    components: {PageBar},
    filters: {
        isRegister(partner) {
            return partner ? '已注册' : '未注册'
        },
        formatAmount(amount) {
            return amount ? amount / 100 + ' 元' : amount + ' 元'
        }
    },
    data() {
        return {
            data: [],
            level_update: {},
            id: 0,
            three_code: '',
            status: "",
            showUpdateStatus: false,
            showConfirmUpdateStatus: false,
            showRemarks: false,
            showRemarkList: false,
            createRemarkType: false,
            remarkList: [],
            currentUserInfo: {},
            currentUserId: "",
            remarkTextarea: "",
            currentRange: [0, 10],
            statusText: '',
            searchData: {},
            filter: {},
            companyOptionsData: {}
        }
    },
    created() {
        this.loadData([0, 10]);
    },
    methods: {
        async loadData(range) {
            this.data = [];
            this.currentRange = range;
            request.partner
                .post(
                    'mk_order_list',
                    {
                        range: range,
                        filter: this.filter
                    }
                )
                .then(r => {
                    this.data = r.data.list
                });
        },
        getLevelText: function (r, c, v) {
            for (let item of level_enum) {
                if (item.value === v) {
                    return item.text;
                }
            }
            return "";
        },
        getCountText: function (r, c, v) {
            return `￥0.00 | ${v}人`
        },
        getRemarkText: function (remark) {
            if (remark) {
                if (remark.remark.length > 50) {
                    return remark.remark.slice(0, 50) + '...'
                } else {
                    return remark.remark
                }
            } else {
                return ''
            }
        },
        getRemarkTime: function (remark) {
            if (remark) {
                return remark.time.split(" ")[0]
            } else {
                return ''
            }
        },
        handleUpdateStatus: function (id, level) {
            this.showUpdateStatus = true;
            this.id = id;
            this.status = level + ''
        },
        confirmUpdateStatus: function () {
            let that = this
            for (let item of level_enum) {
                if (item.value === Number(that.status)) {
                    that.statusText = item.text;
                }
            }
            console.log(that.statusText)
            this.showConfirmUpdateStatus = true
        },
        handleEdit: function (info) {
            this.currentUserInfo = info
            this.id = info.id
            this.status = info.level + ''
            this.showUpdateStatus = true

        },
        handleAddRemark: function (id) {
            this.showRemarks = true
            this.currentUserId = id
        },
        allRemark: function (id) {
            this.currentUserId = id
            this.getRemarkList()
        },
        getRemarkList: async function () {
            await request.partner.post("remark_list", {
                user_id: this.currentUserId,
                range: [0, 10]
            }).then(resp => {
                console.log(resp)
                this.remarkList = resp.data.list
                this.showRemarkList = true
            })
        },
        cancelRemarks() {
            this.createRemarkType = false
            this.showRemarks = false
            this.remarkTextarea = ""
        },
        handlerSearch: function() {
            let filter = {};
            if (this.searchData.user_id) {
                filter.user_id = this.searchData.user_id;
            }
            if (this.searchData.mobile) {
                filter.mobile = this.searchData.mobile;
            }
            if (this.searchData.nickname) {
                filter.nickname = this.searchData.nickname + "";
            }
            if (
                this.searchData.id &&
                (this.searchData.invite_id || this.searchData.nickname)
            ) {
                this.$alert("UID和(手机号或微信昵称)不能同时搜索", "错误提示", {
                    confirmButtonText: "确定"
                });
                // this.searchError();
                return;
            }

            this.filter = filter
            this.loadData([0, 10])
        },
        async updateRemarks() {
            console.log(this.createRemarkType)
            if (this.createRemarkType) {
                return
            } else {
                this.createRemarkType = true
                if (!this.remarkTextarea) {
                    this.$message.info("请输入内容")
                    this.createRemarkType = false
                } else if (this.remarkTextarea.length > 100) {
                    this.$message.info("最多100字")
                    this.createRemarkType = false
                } else{
                    await request.partner.post("remark_create", {
                        user_id: this.currentUserId,
                        remark: this.remarkTextarea
                    })
                    this.$message.success("提交成功")
                    this.showRemarks = false
                    this.remarkTextarea = ""
                    this.currentUserId = ""
                    this.createRemarkType = false
                    this.loadData(this.currentRange)
                }
            }


        },
        async updateStatus() {
            this.showUpdateStatus = false;
            this.showConfirmUpdateStatus = false
            if (parseInt(this.status) === 10) {
                this.$message.info("不可更改");
            } else {
                await request.partner
                    .post("level_update", {
                        user_id: this.id,
                        level: parseInt(this.status)
                    })
                    .then(() => {
                        this.$message.success("更改成功");
                    });
                await this.loadData(this.currentRange);
            }

        },
    }
}
</script>

<style scoped>
.item {
    width: 200px;
}
.edit-info{
    margin-bottom: 20px;
}
.edit-info span{
    color: #333;
    font-size: 14px;
    margin-right: 20px;
}
.span1{
    display: inline-block;
    width: 130px;
}
.edit-btn-box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

}
.edit-btn-box .el-button{
    margin-bottom: 2px;
    margin-left: 0;
    width: 90px;
}
.all-remark{
    color: #409EFF;
    border: 0;
}
</style>
